<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="descrição"
              rules="required"
            >
              <b-form-group label="Descrição" label-for="v-description">
                <b-form-input
                  id="v-description"
                  v-model="form.descricao"
                  :state="errors.length > 0 ? false : null"
                  placeholder="descrição"
                  :disabled="
                    (!verificarPermissao('ROLE_CORE_ATUALIZAR') && form.id) ||
                    (!verificarPermissao('ROLE_CORE_INSERIR') && form.id)
                  "
                />
                <small data-cy="v-description-validate" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12">
            <b-form-group
              label="Dias para Vencimento"
              label-for="v-diaParaVencimento"
            >
              <b-form-input
                id="v-diaParaVencimento"
                v-model="form.diaParaVencimento"
                type="number"
                placeholder="dias para vencimento"
                :disabled="
                  (!verificarPermissao('ROLE_CORE_ATUALIZAR') && form.id) ||
                  (!verificarPermissao('ROLE_CORE_INSERIR') && form.id)
                "
              />
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="6">
            <b-form-group label="Entrada" label-for="v-check-button">
              <b-form-checkbox
                v-model="form.entrada"
                :checked="form.entrada"
                name="check-button-entrada"
                switch
                inline
                :disabled="
                  (!verificarPermissao('ROLE_CORE_ATUALIZAR') && form.id) ||
                  (!verificarPermissao('ROLE_CORE_INSERIR') && form.id)
                "
              >
                {{ form.entrada ? 'Sim' : 'Não' }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="6">
            <b-form-group label="Saida" label-for="v-check-button">
              <b-form-checkbox
                v-model="form.saida"
                :checked="form.saida"
                name="check-button-saida"
                switch
                inline
                :disabled="
                  (!verificarPermissao('ROLE_CORE_ATUALIZAR') && form.id) ||
                  (!verificarPermissao('ROLE_CORE_INSERIR') && form.id)
                "
              >
                {{ form.saida ? 'Sim' : 'Não' }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <b-col v-if="form.id" cols="12">
            <b-form-group label="Ativo" label-for="v-check-button">
              <b-form-checkbox
                v-model="form.ativo"
                :checked="form.ativo"
                name="check-button"
                switch
                inline
                :disabled="
                  (!verificarPermissao('ROLE_CORE_ATUALIZAR') && form.id) ||
                  (!verificarPermissao('ROLE_CORE_INSERIR') && form.id)
                "
              >
                {{ form.ativo ? 'Sim' : 'Não' }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <!-- submit and reset -->
          <ButtonsFormVue
            :permission-insert="verificarPermissao('ROLE_CORE_INSERIR')"
            :permission-edit="verificarPermissao('ROLE_CORE_ATUALIZAR')"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import { verificarPermissao } from '@/auth/utils'
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'
import mixinsGlobal from '@/mixins'

export default {
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('protocolTypeSettingsModule', {
      protocolType: (state) => state.protocolType
    })
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    ButtonsFormVue
  },
  directives: {
    Ripple
  },
  data() {
    return {
      verificarPermissao,
      titleForm: 'Cadastro de Tipo de Protocolo',
      required,
      form: {
        descricao: '',
        diaParaVencimento: 0,
        entrada: false,
        saida: false,
        ativo: true
      }
    }
  },
  mounted() {
    this.form = JSON.parse(JSON.stringify(this.protocolType))
  },
  methods: {
    cancel() {
      this.$emit('cancelar')
      this.cleanObjeto()
    },
    save() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          if (this.form.id) {
            this.$store
              .dispatch('protocolTypeSettingsModule/edit', this.form)
              .then((response) => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Editar',
                    response.response.data.error
                  )
                  return
                }
                this.showMessageSuccess('Editar', 'Editado com sucesso!')
                this.$refs.form.reset()
                this.cancel()
              })
          } else {
            this.$store
              .dispatch('protocolTypeSettingsModule/insert', this.form)
              .then((response) => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Inserir',
                    response.response.data.error
                  )
                  return
                }
                this.showMessageSuccess('Salvo', 'Incluido com sucesso!')
                this.cleanObjeto()
                this.$refs.form.reset()
              })
          }
        }
      })
    },
    cleanObjeto() {
      this.form = {
        descricao: '',
        diaParaVencimento: 0,
        entrada: false,
        saida: false,
        ativo: true
      }
    }
  }
}
</script>
